import type { Niveau4Lexicon } from '../types';
import { effectiveNiveau4Lexicon, niveau4LexiconLabel } from '../lib/niveau4Lexicon';

interface Niveau4LexiconToggleProps {
  value: Niveau4Lexicon;
  onChange: (next: Niveau4Lexicon) => void;
  compact?: boolean;
}

export default function Niveau4LexiconToggle({
  value,
  onChange,
  compact = false,
}: Niveau4LexiconToggleProps) {
  return (
    <section className={compact ? 'space-y-2' : 'surface p-5'}>
      <p className="label">Ord og sætninger · Niveau 4</p>
      <p className={`text-sm text-muted ${compact ? 'mt-1' : 'mt-2'}`}>
        Vælg dansk eller engelsk. Valget huskes og gælder alle trin i Niveau 4,
        indtil du skifter tilbage.
      </p>
      <div
        className={`flex gap-2 ${compact ? 'mt-2' : 'mt-3'}`}
        role="group"
        aria-label="Sprog for Niveau 4"
      >
        {(['da', 'en'] as const).map((lexicon) => {
          const active = value === lexicon;
          return (
            <button
              key={lexicon}
              type="button"
              onClick={() => onChange(lexicon)}
              aria-pressed={active}
              className={`flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold transition ${
                active
                  ? 'bg-indigo-500 text-white shadow-sm dark:shadow-indigo-500/30'
                  : 'btn-secondary'
              }`}
            >
              {niveau4LexiconLabel(lexicon)}
            </button>
          );
        })}
      </div>
      {!compact && value === 'en' && (
        <p className="mt-2 text-xs text-faint">
          Diktat bruger forudgenereret engelsk lyd fra public/audio/en/ når
          VITE_DICTATION_AUDIO=prerendered — ellers browser-stemme.
        </p>
      )}
    </section>
  );
}

export { effectiveNiveau4Lexicon };
